import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * ProLayout settings, spread into the `layout` plugin config in `./config.ts`.
 *
 * Mostly inert: every top-level route sets `layout: false`, so ProLayout never
 * mounts and the layout fields below (navTheme, contentWidth, fixedHeader,
 * fixSiderbar, colorPrimary, logo) have no effect. The product's real chrome is
 * `src/layouts/BasicLayout` and its palette comes from
 * `src/components/CustomConfigProvider`.
 *
 * Two fields here do still matter:
 * - `pwa`, read by `src/global.tsx` to pick its service-worker strategy;
 * - `title`, the document title.
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // Not the product's colour - see `CustomConfigProvider` for the live palette.
  colorPrimary: '#1DA57A',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'YouthMed',
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  token: {
    // ProLayout style tokens; see the type declarations and
    // https://procomponents.ant.design/components/layout
  },
};

export default Settings;
